








































import { Component, Prop, Mixins, Ref } from "vue-property-decorator";
import { ImageProviderStore } from "@/mixins/imageProviderStore";

@Component
export default class ProfileAvatar extends Mixins(ImageProviderStore) {
  @Ref()
  public readonly fileUpload!: HTMLInputElement;

  // Props

  @Prop({ default: "" })
  public src!: string;

  @Prop({ default: "GB" })
  public locationCountryCode!: string;

  // Data

  public onUploadSuccess = () => this.$emit("avatar-changed");
  public onDeleteSuccess = () => this.$emit("avatar-changed");

  // Methods

  public onFileUploadChange(e: Event) {
    const target = e.target as EventTarget & { files: FileList };
    this.onFileChanged(target.files?.[0]);
    this.fileUpload.value = "";
  }
}
